import React, { CSSProperties } from 'react';

interface Props {
  streamStatus?: 'live' | 'disconnected' | 'ended' | null;
  hasVod: boolean;
}

export function LivestreamStatusBadge({ streamStatus, hasVod }: Props): React.ReactElement | null {
  const isLive = streamStatus === 'live';
  const isEnded = streamStatus === 'ended';

  if (isLive) {
    return (
      <div style={styles.liveBadge}>
        <div style={styles.liveDot} />
        <span style={styles.liveText}>LIVE</span>
      </div>
    );
  }

  if (hasVod) {
    return (
      <div style={styles.recordedBadge}>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="#fff">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/>
        </svg>
        <span style={styles.recordedText}>REPLAY</span>
      </div>
    );
  }

  if (isEnded) {
    return (
      <div style={styles.endedBadge}>
        <span style={styles.endedText}>ENDED</span>
      </div>
    );
  }

  return null;
}

const styles: Record<string, CSSProperties> = {
  liveBadge: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
    backgroundColor: '#ef4444',
    borderRadius: '4px',
    padding: '4px 8px',
  },
  liveDot: {
    width: '6px',
    height: '6px',
    borderRadius: '3px',
    backgroundColor: '#fff',
    animation: 'pulse 2s ease-in-out infinite',
  },
  liveText: {
    color: '#fff',
    fontSize: '11px',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
  },
  recordedBadge: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
    backgroundColor: '#9333ea',
    borderRadius: '4px',
    padding: '4px 8px',
  },
  recordedText: {
    color: '#fff',
    fontSize: '11px',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
  },
  endedBadge: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#6b7280',
    borderRadius: '4px',
    padding: '4px 8px',
  },
  endedText: {
    color: '#fff',
    fontSize: '11px',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
  },
};
